(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scotts-product-accessories"] && !Shopify.designMode) return;
  try {
    
  const formatScottsBundleMoney = (pence) => new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP'
  }).format(pence / 100);

  const updateScottsBundle = (bundle) => {
    const items = Array.from(bundle.closest('.scotts-accessories').querySelectorAll('[data-scotts-bundle-item]:checked:not(:disabled)'));
    const total = items.reduce((sum, item) => sum + Number(item.dataset.price || 0), Number(bundle.dataset.basePrice || 0));
    const totalLabel = bundle.querySelector('[data-scotts-bundle-total]');
    const button = bundle.querySelector('[data-scotts-bundle-add]');
    if (totalLabel) totalLabel.textContent = formatScottsBundleMoney(total);
    if (button) button.disabled = items.length === 0;
  };

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-scotts-bundle-item]')) return;
    const section = event.target.closest('.scotts-accessories');
    const bundle = section && section.querySelector('[data-scotts-bundle]');
    if (bundle) updateScottsBundle(bundle);
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-scotts-bundle-add]');
    if (!button) return;
    const section = button.closest('.scotts-accessories');
    const items = Array.from(section.querySelectorAll('[data-scotts-bundle-item]:checked:not(:disabled)'));
    if (!items.length) return;
    button.disabled = true;
    button.textContent = 'Adding...';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items.map((item) => ({ id: Number(item.value), quantity: 1 })) })
      });
      if (!response.ok) throw new Error('Unable to add extras');
      window.location.assign('/cart');
    } catch (error) {
      button.textContent = 'Please try again';
      button.disabled = false;
    }
  });

  document.querySelectorAll('[data-scotts-bundle]').forEach(updateScottsBundle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scotts-product-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-scotts-thumb]');
    if (!thumb) return;

    const section = thumb.closest('[data-scotts-product-hero]');
    const mainImage = section && section.querySelector('.scotts-pdp__main-image img');
    if (!mainImage) return;

    mainImage.src = thumb.dataset.src || mainImage.src;
    if (thumb.dataset.srcset) mainImage.srcset = thumb.dataset.srcset;
    if (thumb.dataset.alt) mainImage.alt = thumb.dataset.alt;

    section.querySelectorAll('[data-scotts-thumb]').forEach((button) => {
      button.setAttribute('aria-current', button === thumb ? 'true' : 'false');
    });
  });

  const updateScottsQuickCalculator = (calculator) => {
    const lengthInput = calculator.querySelector('[data-scotts-quick-length]');
    const widthInput = calculator.querySelector('[data-scotts-quick-width]');
    const count = calculator.querySelector('[data-scotts-quick-count]');
    const result = calculator.querySelector('[data-scotts-quick-result]');
    const quantity = calculator.closest('.scotts-pdp__buy-panel')?.querySelector('input[name="quantity"]');
    const length = Number.parseFloat(lengthInput?.value);
    const width = Number.parseFloat(widthInput?.value);

    if (!(length > 0) || !(width > 0) || !count || !result) return;

    const boardLengthMm = Number.parseFloat(calculator.dataset.boardLengthMm) || 3600;
    const boardWidthMm = Number.parseFloat(calculator.dataset.boardWidthMm) || 140;
    const boardGapMm = Number.parseFloat(calculator.dataset.boardGapMm) || 0;
    const wastagePercent = Number.parseFloat(calculator.dataset.wastagePercent) || 0;
    const boardCoverage = (boardLengthMm / 1000) * ((boardWidthMm + boardGapMm) / 1000);
    const baseBoards = Math.ceil((length * width) / boardCoverage);
    const quantityWithWastage = (baseBoards * (100 + wastagePercent)) / 100;
    let boardQuantity = Math.max(1, Math.ceil(quantityWithWastage - 1e-9));

    if (quantity) {
      const increment = Number.parseInt(quantity.step, 10) || 1;
      boardQuantity = Math.ceil(boardQuantity / increment) * increment;
      quantity.value = boardQuantity;
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const boardLengthMetres = boardLengthMm / 1000;
    const boardLengthLabel = Number.isInteger(boardLengthMetres)
      ? boardLengthMetres.toFixed(0)
      : boardLengthMetres.toFixed(1);

    count.textContent = `${boardQuantity} ${boardQuantity === 1 ? 'board' : 'boards'}`;
    result.textContent = `Based on this ${boardLengthLabel}m board, including ${wastagePercent}% extra for cuts and waste.`;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-scotts-quick-calculate]');
    if (!button) return;

    const calculator = button.closest('[data-scotts-quick-calculator]');
    if (calculator) updateScottsQuickCalculator(calculator);
  });

  } catch(e) { console.error(e); }
})();
})();
